<div class="funs funs__header funs__header--mobile">
    <img src="../../../../../../assets/v2/LOGO_FUNS_TEXT_RED.png" alt="FUNS Logo">
</div>